import styled from 'styled-components';

export const TextareaContainer = styled.div`
  width: 100%;

  &:focus > .placeholder,
  &:not(:placeholder-shown) > .placeholder {
    color: #222;
  }

  &:not(:placeholder-shown) > .placeholder,
  &:focus > .placeholder {
    color: ${({ error }) => (error ? '#f00' : 'var(--color)')};
    font-family: 'GothamBold';
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    ${({ location }) =>
      location !== '/'
        ? `
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
      `
        : `
        -webkit-box-shadow: 0 0 0 1000px #404040 inset !important;
        -webkit-text-fill-color: white !important;
      `}
  }
`;

export const TextareaGeneral = styled.textarea`
  color: ${({ location }) => (location !== '/' ? 'var(--color)' : '#fff')};
  display: block;
  resize: none;
  max-width: 100%;
  height: 200px;
  background: #f2f2f2;
  padding: 5px;
  margin: 10px 0;
  border-radius: 3px;
  width: 100%;
  outline: none;
  font-size: 1.4rem;
  background: none;
  border: ${({ error }) => (error ? '2px solid #f00' : '2px solid #c0c0c0')};
  transition: border-color 0.3s ease;

  &:disabled {
    background: #ddd;
  }

  &:not(:placeholder-shown),
  &:focus {
    border-color: ${({ error }) => (error ? '#f00' : 'var(--primary)')};
    transition-delay: 0.1s;
  }
`;

export const Label = styled.label`
  width: calc(100% - (var(--field-padding) * 2));
  line-height: 100%;
  transform: translateY(-50%);
  color: ${({ error }) => (error ? '#f00' : '#aaa')};
  transition: top 0.3s ease, color 0.3s ease, font-size 0.3s ease;
  font-size: 1.4rem;
`;

export const LabelIcon = styled.div`
  position: absolute;
  overflow: hidden;
  top: 10px;
  right: 15px;
  z-index: 1000;
  cursor: pointer;
  padding: 0;
  margin: 0;
`;
